import React from "react";
import { ServiceResultItem } from "../../utilities/types/clients/types";
import { CloseCircle } from "iconsax-react";
import BodyMeasurementResultDisplay from "../shared/service-results/BodyMeasurementResultDisplay";
import AutoTaggingResultDisplay from "../shared/service-results/AutoTaggingResultDisplay";
import VisualClothesResultDisplay from "../shared/service-results/VisualClothesResultDisplay";
import GarmentMeasurementResultDisplay from "../shared/service-results/GarmentMeasurementResultDisplay";

interface ClientServiceResultModalProps {
  serviceResult: ServiceResultItem | null;
  onClose: () => void;
}

const ClientServiceResultModal: React.FC<ClientServiceResultModalProps> = ({ serviceResult, onClose }) => {
  if (!serviceResult) return null;

  const renderServiceResult = () => {
    if (!serviceResult.response) {
      return (
        <div className="flex items-center justify-center w-full h-64">
          <p className="text-closed-shutter-300">No result data available</p>
        </div>
      );
    }

    const uploadedImage = serviceResult.inputs?.image || serviceResult.inputs?.img_full_view_body;

    if (serviceResult.service_name === "Body Measurement") {
      if (serviceResult.response.Data) {
        return <BodyMeasurementResultDisplay data={serviceResult.response.Data} />;
      }
    }

    if (serviceResult.service_name === "Auto Tagging") {
      if (serviceResult.response.Data?.Clothes) {
        return <AutoTaggingResultDisplay data={serviceResult.response.Data} uploadedImage={uploadedImage} />;
      }
    }

    if (serviceResult.service_name === "Visual Clothes Search") {
      if (serviceResult.response.Data?.Clothes) {
        return <VisualClothesResultDisplay data={serviceResult.response.Data} uploadedImage={uploadedImage} />;
      }
    }

    if (serviceResult.service_name === "Garment Measurement") {
      if (serviceResult.response.Data) {
        const garmentResult: any = {
          Details: {},
          MetaData: serviceResult.response.Data.MetaData || { Date: new Date().toISOString().split("T")[0], FileNames: [] },
        };

        if (serviceResult.response.Data.Measurements) {
          Object.entries(serviceResult.response.Data.Measurements).forEach(([key, value]: [string, any]) => {
            if (value && value.Size && value.Size > 0) {
              garmentResult[key] = value.Size;
              garmentResult.Details[key] = value;
            }
          });
        }

        return <GarmentMeasurementResultDisplay data={garmentResult} uploadedImage={uploadedImage} />;
      }
    }

    return (
      <div className="w-full p-4 overflow-auto">
        <pre className="text-xs whitespace-pre-wrap text-closed-shutter-300">{JSON.stringify(serviceResult.response, null, 2)}</pre>
      </div>
    );
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
      <div className="relative flex flex-col w-full h-full bg-white">
        <div className="flex items-center justify-between px-6 py-4 border-b border-gorgonzola-blue-50">
          <div>
            <h2 className="text-base font-semibold text-closed-shutter-300">{serviceResult.service_name} Result</h2>
            <p className="text-xs text-closed-shutter-300/70">
              Status: <span className={serviceResult.status === "success" ? "text-green-600" : "text-red-600"}>{serviceResult.status}</span>
            </p>
          </div>
          <button onClick={onClose} className="flex items-center gap-2 px-4 py-2 transition-colors rounded-lg hover:bg-gorgonzola-blue-50">
            <CloseCircle size={24} className="text-closed-shutter-300" />
            <span className="text-sm text-closed-shutter-300">Close</span>
          </button>
        </div>

        <div className="flex-1 p-6 overflow-auto">
          <div className="max-w-4xl mx-auto">{renderServiceResult()}</div>
        </div>
      </div>
    </div>
  );
};

export default ClientServiceResultModal;
